<template>
  <div v-show="show" class="step" :class="{'done':!opened}">
    <div class="step__title" @click="openStep">{{ number + ". " + title }}</div>
    <div v-if="template === 'r'">
      <range-slider-test v-for="(item, index) in sortedItems" :title="title" :item="item" :number="number" :parent="parent" :description="description" :key="index"></range-slider-test>
    </div>
    <div v-else-if="template === 't'">
      <two-sizes-range-step-test v-for="(item, index) in sortedItems" :item="item" :number="number" :parent="parent" :description="description" :key="index"></two-sizes-range-step-test>
    </div>
    <default-step v-else :template="template" :number="number" :items="sortedItems" :parent="parent"></default-step>
    <div class="step__next btn" :class="{'disabled':!done || this.moduleConfigurator.steps[this.number - 1]['DISABLED']}" @click="selectOpt">
      Далее
    </div>
  </div>
</template>

<script>
import {mapState, mapActions} from "vuex";
import DefaultStep            from "@/components/Configurator/DefaultStep";
// import RangeSlider            from "@/components/Configurator/RangeSlider";
// import TwoSizesStep           from "@/components/Configurator/TwoSizesStep";
// import TwoSizesRangeStep      from "@/components/Configurator/TwoSizesRangeStep";
import TwoSizesRangeStepTest  from "@/components/Configurator/TwoSizesRangeStepTest";
import RangeSliderTest        from "@/components/Configurator/RangeSliderTest";

export default {
  name       : "ConfiguratorStep",
  components : {
    // RangeSlider,
    RangeSliderTest,
    DefaultStep,
    // TwoSizesStep,
    TwoSizesRangeStepTest
  },
  props      : ["number", "items", "title", "parent", "template", "description", "selected"],
  data()
  {
    return {
      clicked     : true,
      firstSelect : true,
      sortedItems : Object
    };
  },
  watch    : {
    "selected"()
    {
      if(!this.selected.id)
      {
        this.clicked     = true;
        this.firstSelect = true;
      }
    },
    "parentShowNext"( newVal, oldVal )
    {
      if(oldVal === true && newVal === false)
      {
        this.firstSelect = true;
        this.clicked     = true;
      }
    }
  },
  methods  : {
    ...mapActions([
      "GET_STEPS", "SET_PARENT", "SET_SELECT"
    ]),
    openStep()
    {
      if(this.moduleConfigurator.steps[this.number - 1]["showNext"])
      {
        this.clicked = !this.clicked;
      }
    },
    selectOpt()
    {
      if(!this.selected.id) return;
      this.moduleConfigurator.steps[this.number - 1]["showNext"] = true;
      this.firstSelect                                           = false;
      this.clicked                                               = !this.clicked;
      this.moduleConfigurator.solidPart
                                                                 = (this.moduleConfigurator.door ?? this.moduleConfigurator.changeSizes.door) - this.moduleConfigurator.doorPanel - this.moduleConfigurator.doublePart;
      localStorage.readyForOrder                                 = false;
      localStorage.steps                                         = JSON.stringify(this.moduleConfigurator.steps);
      localStorage.rInd                                          = JSON.stringify(this.moduleConfigurator.rInd);
      localStorage.parent                                        = JSON.stringify(this.moduleConfigurator.parent);
      localStorage.changeSizes                                   = JSON.stringify(this.moduleConfigurator.changeSizes);
      localStorage.pallet                                        = JSON.stringify(this.moduleConfigurator.pallet);
      localStorage.lastChanges                                   = JSON.stringify(this.moduleConfigurator.lastChanges);
      localStorage.doublePart                                    = JSON.stringify(this.moduleConfigurator.doublePart);
      localStorage.doorPanel                                     = JSON.stringify(this.moduleConfigurator.doorPanel);
      localStorage.solidPart                                     = JSON.stringify(this.moduleConfigurator.solidPart);
      localStorage.width                                         = JSON.stringify(this.moduleConfigurator.width);
      localStorage.door                                          = JSON.stringify(this.moduleConfigurator.door);
      localStorage.needPrevDouble
                                                                 = JSON.stringify(this.moduleConfigurator.needPrevDouble);
      localStorage.needPrevSolid
                                                                 = JSON.stringify(this.moduleConfigurator.needPrevSolid);
    }
  },
  computed : {
    ...mapState([
      "moduleConfigurator"
    ]),
    parentShowNext()
    {
      if(this.moduleConfigurator.steps[this.number - 2])
      {
        return this.moduleConfigurator.steps[this.number - 2]["showNext"];
      }
      else
      {
        return true;
      }
    },
    show()
    {
      if(this.number === 1)
      {
        return true;
      }
      else
      {
        return this.moduleConfigurator.steps[this.number - 2]["showNext"];
      }
    },
    done()
    {
      return Boolean(this.selected.id);
    },
    opened()
    {
      return !this.done || this.clicked || this.firstSelect;
    }
  },
  async created()
  {
    if(this.moduleConfigurator.steps[this.number - 1]["showNext"])
    {
      this.clicked     = false;
      this.firstSelect = false;
    }
    this.sortedItems = Object.values(this.items).sort(( first, second ) =>
    {
      return parseInt(first.SORT) - parseInt(second.SORT);
    });
  }
};

</script>

<style scoped>

</style>